<template>
  <main class="share">
<!--    <transition name="fade">-->
<!--      <popup v-if="isShown" @close="hideModal">-->
<!--        <popup-socials slot="content"/>-->
<!--      </popup>-->
<!--    </transition>-->

    <viewport-height>
      <div class="share__wrapper">
<!--        <share-item-->
<!--            :item="options.sharePersonal"-->
<!--            :is-personal="true"-->
<!--            @handleDownload="handleDownload"-->
<!--            @handlePrint="handlePrint"-->
<!--            @handleShare="handleShare"-->
<!--        />-->
        <share-item
            :item="options.sharePersonal"
            :is-personal="true"
            @handleDownload="handleDownload"
        />
<!--        @handlePrint="handlePrint"-->
<!--        <share-item-->
<!--            :item="options.shareRetailer"-->
<!--            :is-personal="false"-->
<!--            @handleFindRetailer="handleFindRetailer"-->
<!--        />-->
      </div>
    </viewport-height>

    <!-- download -->
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        :filename="model.name"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        ref="download"
    >
      <pdf-content slot="pdf-content" :style="{height: '1122px'}"/>
    </vue-html2pdf>

    <!-- print -->
<!--    <vue-html2pdf-->
<!--        :show-layout="false"-->
<!--        :float-layout="true"-->
<!--        :enable-download="false"-->
<!--        :preview-modal="true"-->
<!--        :paginate-elements-by-height="1400"-->
<!--        :filename="model.name"-->
<!--        :pdf-quality="1"-->
<!--        :manual-pagination="false"-->
<!--        pdf-format="a4"-->
<!--        pdf-orientation="portrait"-->
<!--        pdf-content-width="800px"-->
<!--        ref="print"-->
<!--    >-->
<!--      <pdf-content slot="pdf-content" :style="{height: '1122px'}"/>-->
<!--    </vue-html2pdf>-->
  </main>
</template>

<script>
import {mixin} from '../mixin';
import viewportHeight from './components/viewportHeight.vue';
import shareItem from './components/shareItem.vue';
import resultModel from './components/resultModel.vue';
// import Popup from './components/popup.vue';
// import popupSocials from './components/popupSocials.vue';
import pdfContent from './components/pdfContent.vue';

export default {
  name: 'shareElement',
  mixins: [mixin],
  components: {
    viewportHeight,
    shareItem,
    resultModel,
    // Popup,
    // popupSocials,
    pdfContent,
  },
  data() {
    return {
      // isShown: false,
    };
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
    model() {
      return this.$store.state.selectedResult;
    },
    sharePersonalPDF() {
      return this.$store.state.siteData.sharePersonalPDF;
    },
  },
  methods: {
    handleDownload() {
      this.$refs.download.generatePdf();
    },
    // handlePrint() {
    //   this.$refs.print.generatePdf();
    // },
    // handleShare() {
    //   this.isShown = true;
    //   this.scrollHide();
    // },
    handleFindRetailer() {
      this.$router.push({name: 'ShareRetailer'});
    },
    // hideModal() {
    //   this.isShown = false;
    //   this.scrollShow();
    // },
  },
};
</script>

<style lang="scss">
@import '../../sass/setup.scss';

body {
  .vue-html2pdf .layout-container.show-layout {
    align-items: center;
    background: $c-light-gray;
  }

  .vue-html2pdf .pdf-preview {
    @include mobile {
      min-width: unset !important;
    }
  }

  .vue-html2pdf .pdf-preview button {
    color: transparent !important;
    background: $c-light-beige !important;

    &::before,
    &::after {
      @include pseudo();
      top: 8px;
      left: 16.5px;
      width: 1px;
      height: 20px;
      background-color: $c-black;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }
}
</style>

<style scoped lang="scss">
@import '../../sass/setup.scss';

.share {
  position: relative;
  z-index: 1;

  &__wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    @include up-tablet {
      //display: grid;
      //grid-template-rows: repeat(2, 1fr);
    }

    @include up-laptop {
      margin: auto 0;
      height: auto;
      flex-direction: row;
      //display: grid;
      //grid-template-columns: repeat(2, 1fr);
      //grid-template-rows: 1fr;
    }

    &::before {
      @include up-laptop {
        @include pseudo();
        top: 0;
        left: 0;
        z-index: -1;
        //width: 50%;
        width: 100%;
        height: 100%;
        background-color: $c-light-beige;
      }
    }
  }
}
</style>
